import {
  DELETE_OTAP_AGENT_API,
  GET_OTAP_AGENT_API,
  SEARCH_OTAP_AGENTS_API,
  SEARCH_OTAP_AGENTS_SIMPLE_API,
  UPDATE_OTAP_AGENT_API
} from '~/constants/APIs'
import {
  IOtapAgentData,
  IOtapAgentForm,
  IOtapAgentSearchForm,
  IOtapAgentSearchResponse
} from '~/models'
import axiosClient from './axiosClient'

export const otapAgentApis = {
  searchOtapAgents: (params: IOtapAgentSearchForm | null) =>
    axiosClient.get(SEARCH_OTAP_AGENTS_API, {
      params
    }) as unknown as IOtapAgentSearchResponse,
  searchOtapAgentsSimple: (params: IOtapAgentSearchForm | null) =>
    axiosClient.get(SEARCH_OTAP_AGENTS_SIMPLE_API, {
      params
    }) as unknown as Promise<IOtapAgentSearchResponse>,
  getOtapAgent: (id: number) =>
    axiosClient.get(GET_OTAP_AGENT_API + id) as unknown as IOtapAgentData,
  updateOtapAgent: (data: IOtapAgentForm) =>
    axiosClient.put(UPDATE_OTAP_AGENT_API + data.id, data),
  deleteOtapAgent: (data: any) => axiosClient.delete(DELETE_OTAP_AGENT_API, { data })
}
